<data-container [title]="renderingProperties.title">
  <fab-data-table [table]="table" [columnOptions]="columnOptions" [descriptionColumnName]="descriptionColumnName" [allowColumnSearch]="allowColumnSearch" [tableHeight]="tableHeight" [description]="tableDescription" [searchPlaceholder]="searchPlaceholder">
  </fab-data-table>
</data-container>
